import {
  WuModal,
  WuModalContent,
  WuModalFooter,
  WuModalHeader,
} from '@npm-questionpro/wick-ui-lib'
import {ReactNode} from 'react'
import styles from './BaseModal.module.scss'

interface IBaseModalProps {
  children: ReactNode
  visible: boolean
  onCloseModal: () => void
  isLoading?: boolean
  headerTitle?: string | ReactNode
  hideHeader?: boolean
  headerClassName?: string
  trigger?: ReactNode
  maxWidth?: string
  variant?: 'action' | 'upgrade' | 'critical'
  footer?: ReactNode | null
  styleContent?: React.CSSProperties
}

export const BaseModal: React.FC<IBaseModalProps> = ({
  children,
  visible,
  onCloseModal,
  isLoading = false,
  headerTitle = '',
  hideHeader = false,
  trigger,
  maxWidth = '800px',
  variant = 'action',
  footer = null,
  styleContent,
}) => {
  return (
    <WuModal
      data-theme="wuexp"
      open={visible}
      onOpenChange={open => {
        if (!open && !isLoading) {
          onCloseModal()
        }
      }}
      Trigger={trigger}
      maxWidth={maxWidth}
      variant={variant}
      allowExternalPortals
    >
      {!hideHeader && <WuModalHeader>{headerTitle}</WuModalHeader>}
      <WuModalContent className="base-modal-content" style={styleContent}>
        {children}
      </WuModalContent>
      <WuModalFooter className={footer ? '' : styles.baseModalFooterEmpty}>
        {footer}
      </WuModalFooter>
    </WuModal>
  )
}
